var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('choice-vote-content',{attrs:{"items":_vm.items}}),(_vm.items.length >  5)?_c('div',{staticClass:"mt-3"},[_c('el-button',{staticClass:"w-full",on:{"click":_vm.onShowMoreRank}},[_vm._v("查看更多排名")])],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }